export const OMNI_TEST_EMAIL = {
  ACCEPT: 'accepttest@ocrf.co.uk',
  DECLINE: 'declinetest@ocrf.co.uk',
  REFER: 'refertest@ocrf.co.uk',
};

export const ALLIUM_TEST_MIDDLE_NAME = {
  ACCEPT: 'TestAccept',
  DECLINE: 'TestDecline',
  REFER: 'TestRefer',
};

export const HUMM_TEST_STREET = {
  ACCEPT: 'warning-ob-accept',
};

export const HUMM_TEST_SUB_500_STREET = {
  ACCEPT: 'Accept',
};

export const ETIKA_TEST_MONTHLY_INCOME = {
  ACCEPT: 200000,
  DECLINE: 10000,
  REFER: 100000,
};

export const ETIKA_TEST_FIRST_NAME = {
  ACCEPT: 'mock',
  DECLINE: 'mock decline',
  REFER: 'mock warn',
  MIXED: 'mock mixed',
};
